import React from 'react';

import { HealthieTag } from '../hooks/queries/appointment-by-room-name/types';
import { CallPhase, tagActionEngine } from '../utils/tagActions';

interface PreCallTagActionsProps {
  tags?: HealthieTag[];
}

const PreCallTagActions: React.FC<PreCallTagActionsProps> = ({ tags }) => {
  if (!Array.isArray(tags) || tags.length === 0) {
    return null;
  }

  const actions = tagActionEngine.getActionsForPhase(CallPhase.PreCall, tags);

  if (actions.length === 0) {
    return null;
  }

  // Render all actions
  return (
    <>
      {actions.map((action) => (
        <React.Fragment key={action.id}>{action.renderAction()}</React.Fragment>
      ))}
    </>
  );
};

export default PreCallTagActions;
